import React from "react";
import "./investment1.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Madisonimages from "../../../Media/Ruko Paramount/Madison Grande/Madison";
import westvillageimages from "../../../Media/Ruko BSD/West Village/westvillage";
import Xlaneimages from "../../../Media/Ruko BSD/Xline/Xlane";
import HamptonEastimages from "../../../Media/Ruko Paramount/Hampton East/HamptonEast";
import MentengStudioimages from "../../../Media/Ruko Paramount/Menteng Studio Loft/MentengStudio";
import MagioreBusinessimages from "../../../Media/Ruko Paramount/Magiore Business/MagioreBusiness";
import NavaparkBusinessimages from "../../../Media/Ruko BSD/Navapark Business Suites/NavaparkBusiness.js";

const imageMap = {
  Madisonimages,
  Xlaneimages,
  westvillageimages,
  HamptonEastimages,
  MentengStudioimages,
  MagioreBusinessimages,
  NavaparkBusinessimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Briza" className="produk">
      <h1>Office Recommendation for Business </h1>
      <h2>Best Choice Office to Start Your Business</h2>
      <div className="cardhome-container1">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
